import { useState, useEffect } from "react";
import { getAllByClanakId } from "../../services/statistikaClanka.service";
import clanakService from "../../services/clanak.service";
import "./TopDesetClanaka.css";

const TopClanci = () => {
  const [topClanci, setTopClanci] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopClanci = async () => {
      setLoading(true);
      try {
        const { data: clanci } = await clanakService.getAll();
        const clanciSaPosjetama = await Promise.all(
          clanci.map(async (clanak) => {
            try {
              const { data } = await getAllByClanakId(clanak.id);
              const brojPosjeta = Array.isArray(data) ? data.length : 0;

              return { ...clanak, broj_posjeta: brojPosjeta };
            } catch (error) {
              return { ...clanak, broj_posjeta: 0 };
            }
          })
        );

      
        const top10 = clanciSaPosjetama
          .sort((a, b) => b.broj_posjeta - a.broj_posjeta)
          .slice(0, 10);
        setTopClanci(top10);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchTopClanci();
  }, []);

  return (
    <div className="topdeset-clanka-div">
      <h3 className="topdeset-clanaka-h3"> Top 10 najposjećenijih članaka</h3>
      {loading ? (
        <p>🔄 Učitavanje...</p>
      ) : (
        <ol className="topdeset-clanaka-ol">
          {topClanci.map((clanak, index) => (
            <li key={clanak.id}>
              <strong className="topdeset-clanaka-strong">
                {clanak.naslov}
              </strong>
              - broj posjeta: {clanak.broj_posjeta}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default TopClanci;
